import $ from "jquery";
import {
  Template,
  MountedCartOrderDeliverySelect,
  InvokeChangeCartOrderDelivery,
  CloseDialog,
  NextStep,
  ShowDialog,
  InvokeDialogStepper,
  CreateDialogMessage,
  HideAllDialog,
  IsAcceptedDialogByMenuKey,
  MountedCartOrderDeliveryButton,
  InvokeChangeCartOrderDeliveryConfirmDialog,
  dialogType,
} from "./types";

/**
 * ダイアログテンプレート
 * @param message ダイアログメッセージ
 * @param type ダイアログタイプ
 */
export const template: Template = (message, type = dialogType.default) => `
  <div class="s-alert js-cart-dialog">
    <div id="js-alert-overlay" class="s-alert__overlay"></div>
    <div class="s-alert__content">
      <div class="s-alert__frame">
        <div class="s-alert__body">
          <p>${message}</p>
        </div>
        <div class="flex justify-center">
          ${
            type === dialogType.default
              ? `<button class="js-dialog-next s-alert__btn s-button--solid s-button--primary">
                  <span class="icon-check icon-check--white"></span>
                  確認しました
                </button>`
              : ""
          }
          ${
            type === dialogType.reserve
              ? `<button class="js-dialog-next s-alert__btn s-alert__btn-next s-button--solid s-button--primary">はい</button>
                <button class="js-dialog-cancel s-alert__btn s-alert__btn-cancel s-button--solid s-button--secondary">いいえ</button>`
              : ""
          }
          ${
            type === dialogType.error
              ? `<button class="js-dialog-next s-alert__btn s-button--solid s-button--primary">
                  <span class="icon-close icon-close--red"></span>
                  閉じる
                </button>`
              : ""
          }
        </div>
      </div>
    </div>
  </div>
`;

/**
 * 要素の存在確認をし、存在した場合イベントハンドラを登録する
 * @param existsElement 要素の存在確認を行う関数
 * @param addEvent 要素にイベントをバインドする関数
 * @param getInputValue 要素の値を取得する関数
 * @param invokeChangeCartOrderDelivery お届け日変更処理
 * @param selector 指定した要素
 */
export const mountedCartOrderDeliverySelect: MountedCartOrderDeliverySelect = (
  existsElement,
  addEvent,
  getInputValue,
  invokeChangeCartOrderDelivery,
  selector
) => () => {
  if (!existsElement(selector)) return;
  const current = getInputValue(selector);
  addEvent(selector, "change", invokeChangeCartOrderDelivery, { current });
};

/**
 * 要素の存在確認をし、存在した場合イベントハンドラを登録する
 * @param existsElement 要素の存在確認を行う関数
 * @param addEvent 要素にイベントをバインドする関数
 * @param invokeChangeCartOrderDeliveryConfirmDialog 確認ダイアログ処理
 * @param selector 指定した要素
 */
export const mountedCartOrderDeliveryButton: MountedCartOrderDeliveryButton = (
  existsElement,
  addEvent,
  invokeChangeCartOrderDeliveryConfirmDialog,
  selector
) => () => {
  if (!existsElement(selector)) return;
  addEvent(selector, "click", invokeChangeCartOrderDeliveryConfirmDialog);
};

/**
 * お届け日変更処理
 * @param existsElement 要素の存在確認を行う関数
 * @param setInputValue 要素に値をセットする関数
 * @param getInputValue 要素の値を取得する関数
 * @param setAttribute 属性を設定する関数
 * @param removeAttribute 属性を削除する関数
 * @param closeDialog ダイアログを閉じる関数
 * @param nextStep ダイアログの確認後に実行する関数
 * @param isConfirmedSelector 注文未確定判定セレクタ
 * @param dialogSelector お届け日変更アラートセレクタ
 */
export const invokeChangeCartOrderDelivery: InvokeChangeCartOrderDelivery = (
  existsElement,
  setInputValue,
  getInputValue,
  setAttribute,
  removeAttribute,
  closeDialog,
  nextStep,
  isConfirmedSelector,
  dialogSelector
) => (event) => {
  const target = (event as any).currentTarget;
  if (!existsElement(isConfirmedSelector)) return;
  const $dialog = $(dialogSelector);
  const isConfirmed = getInputValue(isConfirmedSelector);
  const action = getInputValue(target);
  if (isConfirmed === "false") {
    $dialog.fadeIn();
    setAttribute(target, "disabled", "disabled");
  } else {
    window.location.href = `${action}`;
  }
  closeDialog($dialog, () => {
    setInputValue(target, (event as any).data.current);
    removeAttribute(target, "disabled");
    $dialog.fadeOut();
  });
  nextStep(
    $dialog,
    () => {
      window.location.href = `${action}`;
      $dialog.fadeOut();
    },
    () => {}
  );
};

/**
 * お届け日変更処理
 * @param existsElement 要素の存在確認を行う関数
 * @param addEvent 要素にイベントをバインドする関数
 * @param removeEvent 要素からイベントを削除する関数
 * @param setAttribute 属性を設定する関数
 * @param removeAttribute 属性を削除する関数
 * @param invokeSubmitOrderConfirmForm フォームを送信する関数
 * @param dialogSelector ダイアログ要素
 * @param confirmSelector 確認ハンドラ要素
 * @param cancelSelector キャンセルハンドラ要素
 */
export const invokeChangeCartOrderDeliveryConfirmDialog: InvokeChangeCartOrderDeliveryConfirmDialog = (
  existsElement,
  addEvent,
  removeEvent,
  setAttribute,
  removeAttribute,
  invokeSubmitOrderConfirmForm,
  dialogSelector,
  confirmSelector,
  cancelSelector
) => (event) => {
  event.preventDefault();
  const target = (event as any).currentTarget;
  if (!existsElement(dialogSelector)) return;
  const $dialog = $(dialogSelector);
  setAttribute(target, "disabled", "disabled");
  $dialog.fadeIn();
  addEvent(confirmSelector, "click", () => {
    removeAttribute(target, "disabled");
    removeEvent(confirmSelector, "click");
    $dialog.fadeOut();
    invokeSubmitOrderConfirmForm();
  });
  addEvent(cancelSelector, "click", () => {
    removeAttribute(target, "disabled");
    removeEvent(cancelSelector, "click");
    $dialog.fadeOut();
  });
};

/**
 * ダイアログを閉じる
 * @param addEvent 要素にイベントをバインドする関数
 * @param removeEvent 要素からイベントを削除する関数
 * @param selector 指定した要素
 */
export const closeDialog: CloseDialog = (addEvent, removeEvent, selector) => (
  $dialog,
  end
) => {
  const $close = $dialog.find(selector);
  if (!($close.length > 0)) return;
  addEvent($close, "click", (e: JQuery.Event) => {
    e.stopPropagation();
    end();
    removeEvent(selector, "click");
  });
};

/**
 * ダイアログの確認後に実行する処理
 * @param addEvent 要素にイベントをバインドする関数
 * @param removeEvent 要素からイベントを削除する関数
 * @param selector 指定した要素
 * @param cancelSelector キャンセル処理にバインドされる要素
 * @param overlaySelector オーバーレイセレクタ
 */
export const nextStep: NextStep = (
  addEvent,
  removeEvent,
  selector,
  cancelSelector,
  overlaySelector
) => ($dialog, next, cancel) => {
  const $confirm = $dialog.find(selector);
  const $cancel = $dialog.find(cancelSelector);
  if (!($confirm.length > 0)) return;
  const namespace = Math.floor(Math.random() * 1000) + 1;
  const eventType = `click.${namespace}`;
  addEvent($dialog, eventType, (e: JQuery.Event) => {
    e.stopPropagation();
  });
  const $overlayElement = $dialog.find(overlaySelector);
  addEvent($overlayElement, eventType, (e: JQuery.Event) => {
    e.stopPropagation();
  });
  addEvent($confirm, eventType, (e: JQuery.Event) => {
    e.stopPropagation();
    removeEvent(selector, eventType);
    next();
  });
  addEvent($cancel, eventType, (e: JQuery.Event) => {
    e.stopPropagation();
    removeEvent(cancelSelector, eventType);
    cancel();
  });
};

/**
 * ダイアログ表示
 * @param target ダイアログ要素を注入する要素
 * @param attributeName イベント制御の属性名
 * @param template ダイアログテンプレート
 * @param nextStep ダイアログの確認後に実行する関数
 */
export const showDialog: ShowDialog = (
  target,
  attributeName,
  template,
  nextStep
) => (message, type, success, cancel = () => {}) => {
  const $dialog = $(template(message, type));
  const $target = $(target);
  $dialog.appendTo($target);
  $dialog.fadeIn().css("display", "flex");
  $target.attr(attributeName, "false");
  nextStep(
    $dialog,
    () => {
      $dialog.remove();
      $target.attr(attributeName, "true");
      success();
    },
    () => {
      $dialog.remove();
      $target.attr(attributeName, "true");
      cancel();
    }
  );
};

/**
 * お届け予定商品更新時のダイアログのステップ
 * @param showDialog ダイアログ表示関数
 * @param createDialogMessage ダイアログメッセージ生成関数
 * @param isAcceptedDialogByMenuKey ダイアログ承諾済みキーの比較関数
 * @param set storageのセッター関数
 * @param getInputValue 要素の値を取得する関数
 * @param beginnerSelector ビギナー値をセットするセレクタ
 * アラート出しわけ条件値
 * ・isAccepted: アラート表示したかどうか
 * ・isBeginner: ビギナーかどうか
 * ・isBulkAction: 一括処理かどうか
 */
export const invokeDialogStepper: InvokeDialogStepper = (
  showDialog,
  createDialogMessage,
  isAcceptedDialogByMenuKey,
  set,
  getInputValue,
  beginnerSelector
) => (
  isReserved,
  isBulkAction,
  itemNames,
  menuYear,
  menuNum,
  success,
  cancel
) => {
  const message = createDialogMessage(itemNames);
  const key = `${menuYear}:${menuNum}`;
  const isAccepted = isAcceptedDialogByMenuKey(key);
  const isBeginner = getInputValue(beginnerSelector) === "true";
  const _ = () => {};
  if (isReserved) {
    // NOTE: 予約商品
    isBulkAction
      ? showDialog(
          message,
          dialogType.reserve,
          () =>
            showDialog(
              createDialogMessage(),
              dialogType.default,
              () => {
                success();
                set(key);
              },
              _
            ),
          () =>
            showDialog(
              createDialogMessage(),
              dialogType.default,
              () => {
                cancel();
                set(key);
              },
              _
            )
        )
      : !isAccepted && isBeginner
      ? showDialog(
          message,
          dialogType.reserve,
          () =>
            showDialog(
              createDialogMessage(),
              dialogType.default,
              () => {
                success();
                set(key);
              },
              _
            ),
          cancel
        )
      : showDialog(message, dialogType.reserve, success, cancel);
  } else {
    // NOTE: 通常商品
    isBulkAction || (!isAccepted && isBeginner)
      ? showDialog(
          message,
          dialogType.default,
          () => {
            success();
            set(key);
          },
          _
        )
      : success();
  }
};

/**
 * ダイアログメッセージを返す
 * @param defaultMessage 通常商品用メッセージ
 * @param reservedMessage 予約商品行用メッセージ
 * @param sentenceEnd 予約商品用文末
 */
export const createDialogMessage: CreateDialogMessage = (
  defaultMessage,
  reservedMessage,
  sentenceEnd
) => (itemNames = []) => {
  return itemNames.length > 0
    ? itemNames.reduce((s, i) => s + reservedMessage.replace("$name$", i), "") +
        sentenceEnd
    : defaultMessage;
};

/**
 * 表示中のダイアログを全て削除し、指定する要素内の非活性化を解除する
 * @param removeAttribute 属性を削除する関数
 * @param selector 指定する要素
 * @param selectSelector 数量変更セレクタ
 * @param restoreSelector 元に戻すセレクタ
 * @param deleteSelector 削除セレクタ
 */
export const hideAllDialogs: HideAllDialog = (
  removeAttribute,
  selector,
  selectSelector,
  restoreSelector,
  deleteSelector
) => () => {
  const $dialogs = $(selector).find(".js-cart-dialog");
  const $select = $(selector).find(selectSelector);
  const $restore = $(selector).find(restoreSelector);
  const $delete = $(selector).find(deleteSelector);
  removeAttribute($select, "disabled");
  removeAttribute($restore, "disabled");
  removeAttribute($delete, "disabled");
  $dialogs.remove();
};

/**
 * ダイアログ承諾済みキーと一致するかどうか
 * @param get cookie取得関数
 * @returns 承諾済みキーと一致するかどうか
 */
export const isAcceptedDialogByMenuKey: IsAcceptedDialogByMenuKey = (get) => (
  key
) => {
  return get().some((i) => i === key);
};
